import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataSheetReport } from '../../models/reports/data-sheet-report.model';
import { ReportViewerComponent } from '../report-viewer/report-viewer.component';
import { CalculationResult } from '../../models/calculationModels';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReportApiService } from 'src/app/services/report.api.service';
import { JointCompletionCertificate } from '../../models/reports/joint-completion-certificate.model';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ITRReport } from '../../models/reports/itr-report.model';
import { ManagementApiService } from 'src/app/services/management-api.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-create-data-sheet-report',
    templateUrl: './create-data-sheet-report.component.html',
    styleUrls: [
        './create-data-sheet-report.component.scss',
        '../../../../../../node_modules/jquery-ui/themes/base/all.css',
        '../../../../../../node_modules/devextreme/dist/css/dx.light.css',
        '../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css',
        '../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css',
        '../../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css',
    ],
})
export class CreateDataSheetReportComponent implements OnInit {
    @Input() calculationResult: CalculationResult;

    dataSheetReport: DataSheetReport[] | JointCompletionCertificate[] | ITRReport[];
    customer: string;
    preparedBy: string;
    dataSheetRef: string;
    comments: string;
    reportData: DataSheetReport | JointCompletionCertificate | DataSheetReport[] | JointCompletionCertificate[];

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private ngbModal: NgbModal,
        private reportApiService: ReportApiService,
        private userUtilityService: UserUtilityService,
        private ngXUiLoaderService: NgxUiLoaderService,
        private managementApiService: ManagementApiService
    ) {
        this.customer = '';
        this.preparedBy = '';
        this.dataSheetRef = '';
        this.comments = '';
    }

    ngOnInit(): void {}

    async closeModalWithResult() {
        let dataSheetReport = new DataSheetReport();

        let datasheetFormValues: any = {};

        datasheetFormValues.datasheetref = this.dataSheetRef;
        datasheetFormValues.customer = this.customer;
        datasheetFormValues.preparedby = this.preparedBy;
        datasheetFormValues.comments = this.comments;
        datasheetFormValues.jointcalculation = this.calculationResult;
        let payload: any = {};
        payload.criteria = [];
        let DataContent = JSON.stringify(datasheetFormValues);
        payload.criteria.push({ DataContent: DataContent });
        this.ngXUiLoaderService.start();

        

        try {
            await this.reportApiService.callReports('JointDataSheetReport', payload, 'getdatasheet');
            this.ngbActiveModal.close();
            this.ngXUiLoaderService.stop();
        } catch (error) {
            this.userUtilityService.errorModelPopup(error.message);
            this.ngbActiveModal.close();
            this.ngXUiLoaderService.stop();
        }
    }

    closeModal() {
        // will be implemented
        this.ngbActiveModal.close();
    }
}
